export default __webpack_public_path__ + "static/media/2247.d621134e.png";